import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vue-tel__errors"
}

import {computed, onBeforeMount, reactive, ref, watch} from 'vue';
    import {VueTelInput} from 'vue-tel-input';
    import {useVuelidate} from '@vuelidate/core';
    import {helpers, required} from '@vuelidate/validators';
    import {context} from 'vue3-starter/src/typescript/app-context/AppContext';

    interface PhoneSettings {
        defaultCountryCode: string;
        lowerCasedSuggestedCountriesForPhoneNumbers: string[];
    }

    interface VueTelInputPhone {
        country: {dialCode: string; iso2: string; name: string};
        countryCallingCode: string;
        countryCode: string;
        formatted: string;
        nationalNumber: string;
        number: string;
        valid: boolean;
    }

    interface VueTelInputInstance {
        phoneObject: VueTelInputPhone;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumber',
  props: {
        /**
         * The phone number model
         */
        modelValue: {
            type: String,
            default: '',
        },
        /**
         * Whether the phone number should be required (by Vuelidate)
         */
        required: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether the phone number should be lazy validated (by Vuelidate)
         */
        lazyValidation: {
            type: Boolean,
            default: false,
        },
    },
  emits: ["update:modelValue"],
  setup(__props) {

    const props = __props;

    

    const phoneInput = ref<VueTelInputInstance>();
    const focusing = ref(false);
    const phoneModel = ref(props.modelValue);

    const valid = (value: string): boolean => {
        return !helpers.req(value) || ((!!value && phoneInput.value?.phoneObject.valid) ?? false);
    };

    const rules = computed(() => ({
        phoneNumber: {
            required,
            valid,
        },
    }));
    const state = reactive({
        phoneNumber: phoneModel,
    });
    const v$ = useVuelidate(rules, state, {$lazy: props.lazyValidation});

    const phoneSettings = ref<PhoneSettings>({
        defaultCountryCode: 'gb',
        lowerCasedSuggestedCountriesForPhoneNumbers: ['fr', 'gb', 'be', 'ch', 'lu', 'de', 'es', 'it'],
    });

    watch(
        () => props.modelValue,
        () => {
            phoneModel.value = props.modelValue;
        },
    );

    onBeforeMount(async () => {
        const [settings, error] = await context.httpService.get<PhoneSettings>(context.registry.entries.getPhoneSettings());

        phoneSettings.value.defaultCountryCode = (settings && settings.defaultCountryCode) || 'gb';
        phoneSettings.value.lowerCasedSuggestedCountriesForPhoneNumbers = (settings && settings.lowerCasedSuggestedCountriesForPhoneNumbers) || [
            'fr',
            'gb',
            'be',
            'ch',
            'lu',
            'de',
            'es',
            'it',
        ];

        if (error) {
            console.error(error);
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_unref(VueTelInput), _mergeProps({
      ref_key: "phoneInput",
      ref: phoneInput,
      key: phoneSettings.value.defaultCountryCode,
      modelValue: phoneModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneModel).value = $event))
    }, _ctx.$attrs, {
      "input-options": {placeholder: _ctx.$msg('generic.phone.placeholder')},
      "preferred-countries": phoneSettings.value.lowerCasedSuggestedCountriesForPhoneNumbers,
      "default-country": phoneSettings.value.defaultCountryCode,
      "style-classes": ['vue-tel', {'vue-tel--focusing': focusing.value}],
      mode: "international",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (focusing.value = true)),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (focusing.value = false))
    }), null, 16, ["modelValue", "input-options", "preferred-countries", "default-country", "style-classes"])),
    (_unref(v$).phoneNumber.$invalid && _unref(v$).phoneNumber.$errors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "errors", {
            errors: _unref(v$).phoneNumber.$errors
          }, () => [
            (_unref(v$).phoneNumber.$errors[0].$validator === 'required')
              ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                  key: 0,
                  "no-html-error-text": _ctx.$msg('generic.phone.required')
                }, null, 8, ["no-html-error-text"]))
              : _createCommentVNode("", true),
            (_unref(v$).phoneNumber.$errors[0].$validator === 'valid')
              ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                  key: 1,
                  "no-html-error-text": _ctx.$msg('generic.phone.incorrect')
                }, null, 8, ["no-html-error-text"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})